export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createCampaign = /* GraphQL */ `
  mutation createCampaign(
    $input: CreateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    createCampaign(input: $input, condition: $condition) {
      id
      createdAt
    }
  }
`;

export const updateCampaign = `
mutation updateCampaign($input: UpdateCampaignInput!) {
  updateCampaign(input: $input) {
    id
    available
  }
}`

export const updateProperty = `
mutation updateProperty($input: UpdatePropertyInput!) {
  updateProperty(input: $input) {
    id
  }
}`

export const createOwnerValidationSession = /* GraphQL */ `
  mutation CreateOwnerValidationSession(
    $input: CreateOwnerValidationSessionInput!
    $condition: ModelOwnerValidationSessionConditionInput
  ) {
    createOwnerValidationSession(input: $input, condition: $condition) {
      id
      token
      propertyID
      ownerId
      status
      expiresAt
      createdAt
      updatedAt
    }
  }
`;

export const updateOwnerValidationSession = /* GraphQL */ `
  mutation UpdateOwnerValidationSession(
    $input: UpdateOwnerValidationSessionInput!
    $condition: ModelOwnerValidationSessionConditionInput
  ) {
    updateOwnerValidationSession(input: $input, condition: $condition) {
      id
      token
      propertyID
      ownerId
      status
      expiresAt
      createdAt
      updatedAt
    }
  }
`;

export const getOwnerValidationSessionByToken = /* GraphQL */ `
  query ListOwnerValidationSessions($filter: ModelOwnerValidationSessionFilterInput) {
    listOwnerValidationSessions(filter: $filter) {
      items {
        id
        token
        propertyID
        ownerId
        status
        expiresAt
        createdAt
        updatedAt
      }
    }
  }
`;